<template lang="pug">
	.creative-actions(v-if="Creative.SelectedCreative")
		.options-button(v-pseudo-modal-show="'creative-actions-dropdown'")
			i.icons.cui-options
		div.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'creative-actions-dropdown'")
			.dropdown-header.text-center
				strong Creative actions
			.dropdown-item(@click="openCreativeSettings")
				span Creative settings
			.dropdown-item(@click="openCreativeAISettings")
				span Creative ai
			.dropdown-item(@click="pullCreative" v-if="Creative.SelectedCreative.type === 'playable' && isGitAvailable()")
				span Pull from repository
					.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('pull-creative-' + Creative.SelectedCreative.id) !== 'done'")
			.dropdown-item(@click="updateCocosCreative" v-if="Creative.SelectedCreative.type === 'playable' && Creative.SelectedCreative.Tags.cocos")
				span Update cocos creative sources
			.dropdown-item(@click="rescanCreative" v-if="Creative.SelectedCreative.type === 'playable' && (User.currentUser.Tags['admin'] || isGitAvailable())")
				span Rescan creative
					.icon.fa.fa-spinner.fa-spin(v-if="Monitoring.getChannelState('rescan-creative-' + Creative.SelectedCreative.id) !== 'done'")
			.dropdown-item(@click="activateAICodeEdit" v-if="isAICodeEditActivationAvailable()")
				span Activate AI code edit
					.icon.fa.fa-spinner.fa-spin(v-if="Creative.aiCodeEditActivatingCreatives[Creative.SelectedCreative.id]")
			.dropdown-item(@click="clearCreativeAssetsCache" v-if="isClearCacheAvailable()")
				span Clear creative assets cache
			.dropdown-item(@click="copyChanges" v-if="Creative.SelectedCreative.type === 'playable' && false")
				span Copy changes
			.dropdown-item(@click="pasteChanges" v-if="Creative.SelectedCreative.type === 'playable' && false && checkPasteAvailability() && copyState['paste'] && copyState['title']")
				span Paste changes from
				br
				strong {{copyState['title']}}
			.dropdown-item.blue(@click="moveToPreviousWorkspace" v-if="Creative.SelectedCreative && getPreviousWorkspace()")
				span Move to {{previousWorkspace.title}} workspace
			.dropdown-item.blue(@click="moveToNextWorkspace" v-if="Creative.SelectedCreative && getNextWorkspace()")
				span Move to {{nextWorkspace.title}} workspace
			.dropdown-item.blue(@click="moveToArchiveWorkspace" v-if="Creative.SelectedCreative && !creativeTags['workspace-archive']")
				span Move to Archive
			//.dropdown-item.green(@click="markAsReleased" v-if="!creativeTags['released'] && Creative.SelectedCreative.type === 'playable' && User.currentUser.Tags['admin']")
				span Load combined js files
			//.dropdown-item.red(@click="returnInDevelopment" v-if="creativeTags['released'] && Creative.SelectedCreative.type === 'playable' && User.currentUser.Tags['admin']")
				span Load separated js files
			.dropdown-item.green(@click="showCreative" v-if="creativeTags['hidden'] && User.currentUser.Tags['admin'] && Creative.SelectedCreative.type === 'playable'")
				span Show creative to client
			.dropdown-item.red(@click="hideCreative" v-if="!creativeTags['hidden'] && User.currentUser.Tags['admin'] && Creative.SelectedCreative.type === 'playable'")
				span Hide creative from client
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Metadata } 		from './../../services/Metadata';
	import { User } 			from './../../services/User';
	import { Creative } 			from './../../services/Creative';
	import { Monitoring } 		from './../../services/Monitoring';
	import { Publisher } 		from "./../../services/Publisher";
	import { Server } 			from "./../../services/Server";

	export default {
		name: "CreativeActions",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Publishers Changed", "Current User Changed", "Creative Changed", "Selected Creative Changed", "Pseudo Modal Showed creative-actions-dropdown"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				},
				"AI Code Edit Activation State Changed": function() {
					this.update();
				}
			}
		},
		data() {

			this.User = User;
			this.Publisher = Publisher;
			this.Creative = Creative;
			this.Monitoring = Monitoring;

			this.creativeTags = {};
			this.copyState = {
				copy: true,
				paste: false,
				title: null
			};

			this.previousWorkspace = this.getPreviousWorkspace();
			this.nextWorkspace = this.getNextWorkspace();

			return {
				showed: true
			};

		},
		methods: {
			collectData() {

				if (Creative.SelectedCreative) {

					this.creativeTags = _.cloneDeep(Creative.SelectedCreative.Tags);

				}

				this.previousWorkspace = this.getPreviousWorkspace();
				this.nextWorkspace = this.getNextWorkspace();

			},

			copyChanges() {

				console.log('Copy changes');

				Settings.cloneData = {
					versionId: Version.SelectedVersion.id
				};

				//TODO: почему запрещается копировать заново? если человек передумал или скопировал не то по ошибке?
				this.copyState = {
					copy: false,
					paste: true
				};

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			openCreativeSettings() {

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

				Broadcast.call("Show CreativeSettings", []);

			},

			openCreativeAISettings() {

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

				Broadcast.call("Show CreativeSettingsAI");

			},

			pasteChanges() {

				console.log('Paste changes');

				if (Settings.cloneData && Settings.cloneData.versionId && this.checkPasteAvailability()) {

					throw new Error("Нужно отправить запрос на сервер с информацией откуда и куда скопировать (два id версий креатива) и всё делать там, а не на клиенте.");

				}

				this.copyState = {
					copy: true,
					paste: false
				};

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			checkPasteAvailability() {

				//TODO: нужно проверять возможность вставки настроек по другому а не через title как было раньше
				return (Settings.cloneData && Settings.cloneData.versionId);

			},

			pullCreative() {

				if (Monitoring.getChannelState('pull-creative-' + Creative.SelectedCreative.id) === 'done') {

					Server.sendToSocket({
						PullCreative: Creative.SelectedCreative.id
					});

				}

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

				Broadcast.call("Show MonitoringLog", ["pull-creative-" + Creative.SelectedCreative.id]);

			},

			updateCocosCreative() {

				Broadcast.call("Show PlayableCreateFromCocosCreator", [Creative.SelectedCreative.id]);

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			rescanCreative() {

				if (Monitoring.getChannelState('rescan-creative-' + Creative.SelectedCreative.id) === 'done') {

					Server.sendToSocket({
						RescanCreative: Creative.SelectedCreative.id
					});

				}

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

				Broadcast.call("Show MonitoringLog", ["rescan-creative-" + Creative.SelectedCreative.id]);

			},

			// Создание копии креатива без привязки к репозиторию, в которой код плейабла может редактировать ИИ агент
			activateAICodeEdit() {

				let creative = Creative.SelectedCreative;

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

				if (Creative.aiCodeEditActivatingCreatives[creative.id]) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Activate AI code edit',
					message: `A new creative will be created as a full copy of "${creative.title}" without the repository link. The new creative can't be updated from the repository, but the code of its playable can be edited with the AI agent. The current creative stays unchanged. Continue?`,
					confirmButtonText: '&nbsp;&nbsp;Create copy',
					confirmButtonIcon: 'fa-clone',
					confirmCallback: () => {

						Server.sendToServer({
							ActivateAICodeEdit: {
								creativeId: creative.id
							}
						});

					}
				}]);

			},

			clearCreativeAssetsCache() {

				Server.sendToSocket({
					ClearCompressionCache: Creative.SelectedCreative.id
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			markAsReleased() {

				Server.sendToSocket({
					MarkAsReleased: Creative.SelectedCreative.id
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			returnInDevelopment() {

				Server.sendToSocket({
					UnmarkAsReleased: Creative.SelectedCreative.id
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			getPreviousWorkspace() {

				if (Layout.workspace === 'testing') return Metadata.WorkspacesByCodename['development'];
				if (Layout.workspace === 'production') return Metadata.WorkspacesByCodename['testing'];
				if (Layout.workspace === 'archive') return Metadata.WorkspacesByCodename['testing'];
				if (Layout.workspace === '12345') return Metadata.WorkspacesByCodename['123456'];

				return '';

			},

			getNextWorkspace() {

				if (Layout.workspace === 'development') return Metadata.WorkspacesByCodename['testing'];
				if (Layout.workspace === 'testing') return Metadata.WorkspacesByCodename['production'];
				if (Layout.workspace === 'archive') return Metadata.WorkspacesByCodename['production'];

				return '';

			},

			moveToPreviousWorkspace() {

				Server.sendToSocket({
					MoveCreativeToWorkspace: {
						creativeId: Creative.SelectedCreative.id,
						workspace: this.getPreviousWorkspace().codename
					}
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			moveToNextWorkspace() {

				Server.sendToSocket({
					MoveCreativeToWorkspace: {
						creativeId: Creative.SelectedCreative.id,
						workspace: this.getNextWorkspace().codename
					}
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			moveToArchiveWorkspace() {

				Server.sendToSocket({
					MoveCreativeToWorkspace: {
						creativeId: Creative.SelectedCreative.id,
						workspace: 'archive'
					}
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			showCreative() {

				Server.sendToSocket({
					UnmarkAsHidden: Creative.SelectedCreative.id
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			hideCreative() {

				Server.sendToSocket({
					MarkAsHidden: Creative.SelectedCreative.id
				});

				Broadcast.call("Pseudo Modal Hide", ['creative-actions-dropdown']);

			},

			isGitAvailable() {

				// Внешне загруженные креативы не имеют репозитория
				if (Creative.SelectedCreative.Tags.external) return false;

				// Копии креативов для редактирования кода ИИ агентом не связаны с репозиторием
				if (Creative.SelectedCreative.options?.aiCodeEdit) return false;

				// Пулл разрешен либо админам либо специально помеченным клиентам
				return User.currentUser.options?.access?.['clone-project-repository'] || Publisher?.SelectedPublisher?.options?.['GitPull'];

			},

			// Редактирование кода ИИ агентом можно активировать для плейабла нового формата MraidSDK (без сборки), привязанного к репозиторию
			isAICodeEditActivationAvailable() {

				let creative = Creative.SelectedCreative;

				return creative.type === 'playable' && !!creative.options?.gitRepositoryName && creative.options?.mraidSDK === true;

			},

			isClearCacheAvailable() {

				return User.currentUser.Tags['admin'] || Publisher?.SelectedPublisher?.options?.['GitPull'];

			}
		}
	}
</script>


<style lang="sass" scoped>

	.options-button
		position: absolute
		top: 5px
		height: 45px
		right: 0
		padding: 0.75rem 1rem
		cursor: pointer
		color: #e4e7ea

	.dropdown-menu
		right: -230px
		width: 245px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

		.dropdown-item.green
			color: #4dbd74

		.dropdown-item.green:hover
			background-color: #4dbd74
			color: #e4e7ea

		.dropdown-item.red
			color: #f86c6b

		.dropdown-item.red:hover
			background-color: #f86c6b
			color: #e4e7ea

		.dropdown-item.blue
			color: #4799eb

		.dropdown-item.blue:hover
			background-color: #4799eb
			color: #e4e7ea

		.dropdown-item.disabled
			color: #73818f

		.icon
			margin-left: 6px

</style>

